import baseAPI from '../axiosApi'

const api={
    list:'/api-ir/international/incoming/page',
    add:'/api-ir/international/incoming/add',
    update:'/api-ir/international/incoming/edit',
    info:'/api-ir/international/incoming/info/',
    del:'/api-ir/international/incoming/delete/',
}
// 查询incoming列表
export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}
// 新增incoming
export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
// 修改incoming
export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}
// 查询incoming信息
export function info (id) {
    return baseAPI.axiosData(api.info+id,'get')
}
// 删除incoming
export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}
